import { InjectionToken } from '@angular/core';
import { makeStateKey } from '@angular/platform-browser';
import { DealerSiteProfile } from './dealer-site.model';

/** Injectado pelo server.ts com o dealerId lido do header X-Dealer-Id / env DEALER_ID */
export const DEALER_ID_TOKEN = new InjectionToken<string | null>(
  'DEALER_ID_TOKEN',
);

/** Injectado pelo server.ts com o host real do pedido (req.headers.host) — usado para SEO (canonical/hreflang/JSON-LD) */
export const SITE_ORIGIN_TOKEN = new InjectionToken<string | null>(
  'SITE_ORIGIN_TOKEN',
);

/** Chave TransferState — profile SSR → browser sem refetch */
export const DEALER_SITE_KEY = makeStateKey<DealerSiteProfile | null>(
  'dealerSite',
);

/** Chave TransferState — dealerId SSR → browser */
export const DEALER_ID_KEY = makeStateKey<string | null>('dealerId');
